import React from 'react';
import { Typography } from '@mui/material';
import { FieldArrayWithId, useFormContext } from 'react-hook-form';
import { Listing } from 'components/shared/TableListing/table/Listing';

import { tradeInListingColumns } from '../../../../lib';
import { TradeInPayoffDetails } from './TradeInPayoffDetails';
import { TradeInListingActionPanelBottom } from './TradeInListingActionPanelBottom';
import { TradeInListingItem, TradeInListingConfig, DealBuilderFormValues } from '../../../../types';

interface Props {
  onAddRow: VoidFunction;
  onRemoveRow: (rowIndex: number) => void;
  fields: FieldArrayWithId<DealBuilderFormValues, 'pricing.tradeIn'>[];
}

export const TradeInListing = ({ fields, onRemoveRow, onAddRow }: Props) => {
  const form = useFormContext<DealBuilderFormValues>();

  return (
    <Listing<TradeInListingItem, TradeInListingConfig>
      tableData={fields}
      columns={tradeInListingColumns}
      injectContext={{ form, onRemoveRow }}
      actionPanelBottom={() => <TradeInListingActionPanelBottom form={form} onAddRow={onAddRow} />}
      renderRowDetail={({ rowIndex }) => <TradeInPayoffDetails rowIndex={rowIndex} form={form} />}
      actionPanelTop={() => (
        <Typography variant="h6" component="span">
          Trade-In
        </Typography>
      )}
    />
  );
};
